module.exports = __webpack_public_path__ + "static/sstep1-4dfeff1a7808a4e2b17546d66f8f2251.png";